import React from "react";
import BeyondBrilliant from "../../../images/about-us/BeyondBrilliant-Tagline-White.png";
import bgImage from "../../../images/about-us/CSC-LED-BackgroundImage1-BlueOverlay.jpg";
import NcImage from "shared/NcImage/NcImage";

const AboutUsBanner = () => {
  return (
    <div
      className="nc-AboutUsBanner flex justify-center w-full h-40 sm:h-96 bg-cover bg-[position:0_61%] bg-inherit"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
       <NcImage
          containerClassName="w-48 sm:w-96"
          className="object-contain w-full h-full"
          src={BeyondBrilliant}
        />
    </div>
  );
};

export default AboutUsBanner;
